import { useState } from "react";
import {
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";

export function MobileNavigationLinks() {
  const [open, setOpen] = useState(false);
  const navItems = [
    { path: "/", label: "HOME" },
    { path: "/about", label: "ABOUT" },
    { path: "/contact", label: "CONTACT" },
    { path: "/work", label: "WORK" },
    { path: "https://github.com/TheoGreenslade", label: "GITHUB" },
    { path: "https://www.linkedin.com/in/theogreenslade/", label: "LINKEDIN" },
  ];

  return (
    <Box
      sx={{
        position: "absolute",
        top: 24,
        right: 24,
        zIndex: 20,
        display: { xs: "block", md: "none" },
      }}
    >
      <IconButton
        onClick={() => setOpen(true)}
        sx={{ color: "#ffffff", p: 1, userSelect: "none" }}
      >
        <MenuIcon sx={{ fontSize: 32, color: "#ffffff" }} />
      </IconButton>
      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        transitionDuration={600}
        PaperProps={{
          sx: {
            backgroundColor: "#141313",
            width: "100%",
            maxWidth: "100%",
            height: "100%",
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            backgroundColor: "#141313",
            p: 4,
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            position: "relative",
            userSelect: "none",
          }}
          role="presentation"
          onClick={() => setOpen(false)}
        >
          <Box sx={{ position: "absolute", top: 24, right: 24, zIndex: 30 }}>
            <IconButton
              aria-label="Close navigation"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
              }}
              sx={{ color: "#ffffff", p: 1, userSelect: "none" }}
            >
              <CloseIcon sx={{ fontSize: 32, color: "#ffffff" }} />
            </IconButton>
          </Box>
          <List sx={{ width: "100%" }}>
            {navItems.map((item) => {
              const isExternal = item.path.startsWith("http");
              const itemProps: any = isExternal
                ? {
                    component: "a",
                    href: item.path,
                    target: "_blank",
                    rel: "noopener noreferrer",
                  }
                : {
                    component: Link,
                    to: item.path,
                  };

              return (
                <ListItem
                  key={item.label}
                  {...itemProps}
                  sx={{
                    minHeight: 0,
                    py: 0,
                    my: 0,
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  <ListItemText
                    primary={
                      <Box
                        component="span"
                        sx={{ display: "block", m: 0, p: 0 }}
                      >
                        <Box
                          component="span"
                          sx={{
                            fontWeight: 400,
                            fontSize: "2rem",
                            lineHeight: 1.1,
                            color: "#ffffff",
                            m: 0,
                            p: 0,
                          }}
                        >
                          {item.label}
                        </Box>
                      </Box>
                    }
                    sx={{ m: 0, p: 0 }}
                  />
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
}
